export const SET_COUPON_CODE = 'SET_COUPON_CODE';
